<template>
<MainContentLayout>
    <Head title="Dashboard" />

    <template #breadcrumb>
        <BreadCrumb />
    </template>
    <template #title>
        {{ $t('label.dashboard') }}
    </template>
</MainContentLayout>
</template>

<script>
import { Head } from '@inertiajs/vue3';

export default {
    setup() {
        return { Head };
    }
};

</script>
